import styled from '@emotion/styled'

export const ButtonGroup = styled.div`
  align-items: stretch;
  display: flex;
  justify-content: center;
  ${p => p.column && 'flex-direction: column;'}
  margin: 0px 4px 8px 4px;
`
export const IconGroup = styled.div`
  align-items: stretch;
  display: flex;
  justify-content: center;
  margin: 8px;
`
export const ButtonGroupWrap = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
`
